@use '../../../scss/settings/colors.scss';
.checkbox_container {
  margin-top: 16px;
}

.modal_container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); // Fondo oscuro semi-transparente
}

.title_container {

  svg {
    width: 30px;
    height: 30px;
  }

}

.textarea_container {
  width: 100%;

  label {
    transform: translate(14px, -9px) scale(0.75) !important;
  }

}

.w100 {
  width: 100%;
}

.title {
  font-size: 16px !important;
  color: colors.$dark-blue;
}

.labels_row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  height: 35px;
  font-family: 'Regular Inter', sans-serif;
  font-size: 14px;
  color: colors.$dark-blue;
}

// ---------- Responsive ----------
.modal_container {
  box-sizing: border-box;
  padding: 16px;
  overflow-y: auto;
}

// ---------- Employee manual instructions (step 1) ----------
.manual_instructions {
  box-sizing: border-box;
  width: 100%;
  max-height: 330px;
  overflow: auto;
  padding: 16px;
  border: 1px solid colors.$gray-variant-18;
  border-radius: 12px;
  background-color: colors.$base-white;
  font-family: 'Regular Inter', sans-serif;
}

.manual_instructions_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 16px;
}

.manual_instructions_title {
  margin: 0;
  font-family: 'SemiBold Inter', sans-serif;
  font-size: 16px;
  line-height: 1.4;
  color: colors.$text-black-2;
}

.manual_instructions_badge {
  flex-shrink: 0;
  padding: 2px 10px;
  border-radius: 999px;
  background-color: colors.$light-purple;
  font-family: 'Medium Inter', sans-serif;
  font-size: 12px;
  line-height: 18px;
  color: colors.$brand-purple;
  white-space: nowrap;
}

.manual_instructions_list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.manual_instructions_step {
  display: flex;
  align-items: flex-start;
  gap: 12px;

  & + & {
    margin-top: 14px;
  }
}

.manual_instructions_number {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: colors.$brand-purple;
  font-family: 'SemiBold Inter', sans-serif;
  font-size: 12px;
  line-height: 1;
  color: colors.$base-white;
}

.manual_instructions_step_title {
  margin: 0 0 2px;
  font-family: 'SemiBold Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: colors.$text-black-2;
}

.manual_instructions_step_text {
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  color: colors.$gray-variant-3;
}

.manual_instructions_note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 16px;
  padding: 10px 12px;
  border: 1px solid colors.$gray-variant-18;
  border-radius: 8px;
  font-size: 13px;
  line-height: 18px;
  color: colors.$gray-variant-3;

  svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-top: 1px;
    color: colors.$brand-purple;
  }
}
